import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import MainSignUp from '../pages/SignUp/MainSignUp';
import LandingPage from '../layouts/LandingPage/';

import Error_404 from '../pages/404';
import Emptys from '../pages/Emptys';

import SignIn from '../pages/SignIn/';
import SignInAdmin from '../pages/AdminSignIn/';

import DashBoard from '../layouts/Dashboard';
import AdditionalInfo from '../pages/AditionalInfo/';
import NewPassword from '../pages/Templates/NewPassword';
import ClientAccount from '../pages/User-Client/';
import FindLawyer from '../pages/FindLawyer/';

import * as ROUTES from '../routes/index';
import Footer from '../components/LandingPage/Footer';
import FooterContainer from '../components/Footers/FooterContainer';
import ThankYou from '../pages/ThankYou';
import LandingPageMarketing from '../layouts/LandingPage300/';
import LandingPage1 from '../layouts/LandingPage1';
import LandingPage2 from '../layouts/LandingPage2';
import LandingPageWebinar from '../pages/LandingPageWebinar';
import LandingPageLeads from '../pages/LandingPageLeads';
import FreemiumMembershipLanding from '../pages/LandingPageFreemiumMembership';
import { connect } from "react-redux";
import { verifyAuth, showNewTerms } from '../store/actions/UserAction'
import FullScreenLoader from '../components/FullScreenLoader';
import ScrollToTop from '../components/ScrollToTop';

import FormRecoverPassword from '../pages/RecoverPasswordFlow/FormRecoverPassword';
import { showLoading, hideLoading } from "../store/actions/LoadingActions";
import {initTagM } from '../utils/Google/TagManager'
import {initGA } from '../utils/Google/Analitycs'
import CookieConsent, { Cookies } from "react-cookie-consent";
import MapGoogle from '../components/MapContainerData';
import ResponseQuestion from "../components/Comunity/responseQuestion";
import ComunityContent from "../components/Comunity";
import ModalNewTerms from '../components/Modal/ModalNewTerms';

const AppRoutes = ({ authClient, verifyAuth, loading, showLoading, hideLoading, showNewTerms }) => {

  useEffect(() => {
    verifyAuth()
    hideLoading()
    if (authClient &&
      (!authClient.termsAndConditions ||
      authClient.termsAndConditions === false)
    ) {
      showNewTerms(true, authClient.role)
    }
    // Google tag Manager
    initTagM('GTM-KB2CPML')
     // Google Analitycs
    initGA('UA-156171724-1') 
  }, [authClient.termsAndConditions])

  return (
    <div>
      {loading && <FullScreenLoader full={true} loading={loading} />}
     
      <BrowserRouter>
     
        <Switch>

          

          <Route component={() => {
    global.window && (global.window.location.href = 'https://contactaabogado.com/comunidad');
    return null;
    }}>
            </Route>


        </Switch>
      </BrowserRouter>
      <CookieConsent
        style={{
          background: "#fafafa",
          alignItems: 'center',
          flexDirection: 'column'
        }}
        buttonText="Aceptar"
        contentStyle={{
          margin: '16px 16px 0 16px',
          flex: '1 0 42px'
        }}
        buttonStyle={{
          width:' 112px',
          height:' 32px',
          borderRadius: '20px',
          backgroundColor: '#013957',
          fontSize: 14,
          fontWeight: 'bold',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 'normal',
          letterSpacing: 'normal',
          textAlign: 'center',
          color: 'white',
          outline: 'none',
        }}
      >
        <p style={{
          fontFamily: 'Lato',
          fontSize: 18,
          fontWeight: 'bold',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 'normal',
          letterSpacing: 'normal',
          textAlign: 'center',
          color: '#013957',
        }}>
          Utilizamos cookies
        </p>

        <p
          style={{
            fontFamily: 'Lato',
            fontSize: 14,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.43,
            letterSpacing: 'normal',
            textAlign: 'center',
            color:'#484848'
          }}
        >
          Este sitio web utiliza cookies, si continuas navegando consideramos que aceptas su uso.
        </p>
        <p
          style={{
            fontFamily: 'Lato',
            fontSize: 14,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.43,
            letterSpacing: 'normal',
            textAlign: 'center',
            color:'#484848'
          }}
        >
          Puedes obtener más información en nuestra <a style={{fontWeight:'bold', color: '#484848', textDecoration: 'none'}} href="/informacion-adicional">política de cookies.</a>
        </p>
      </CookieConsent> 
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  verifyAuth: () => dispatch(verifyAuth()),
  showLoading:() => dispatch(showLoading()), 
  hideLoading:() => dispatch(hideLoading()),
  showNewTerms: (open, role) => dispatch(showNewTerms(open, role))
})

const mapStateToProps = state => ({
  authClient: state.authClient,
  loading: state.LoadingReducer.showLoading
})

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
